import { useSelector, useDispatch } from 'react-redux';
import '../stylesheets/HomePage.css';
import { selectAllStrings } from '../features/language/languageSlice';
import { searchPois } from '../features/pois/poisSlice';
import { useState, useEffect } from 'react';
import { Navbar } from '../app/Navbar';
import SearchModal from '../features/pois/SearchModal';
import { useHistory } from 'react-router';
import FeaturedPoisSection from '../features/pois/FeaturedPoisSection';
import TrendingPoisSection from '../features/pois/TrendingPoisSection';
import NewsSection from '../features/news/NewsSection';
import { getPosition } from '../api/mobile';


const HomePage = () => {
    const dispatch = useDispatch();
    const strings = useSelector(selectAllStrings);
    const [showSearch, setShowSearch] = useState(false);
    const [keyword, setKeyword] = useState('');
    const history = useHistory();

    const [campsites, setCampsites] = useState(true);
    const [serviceAreas, setServiceAreas] = useState(true);
    const [parkingAreas, setParkingAreas] = useState(true);
    const [clubBenefits, setClubBenefits] = useState(true);
    const [attractions, setAttractions] = useState(false);



    const applyFilters = async (filters, address) => {
        if (!filters.location) {
            alert(strings.geolocation_error);
        } else {
            dispatch(searchPois({
                keyword: filters.poiKeyword,
                lat: filters.location.lat(),
                lng: filters.location.lng(),
                camp: filters.campsites,
                serv: filters.serviceAreas,
                sosta: filters.parkingAreas,
                conv: filters.clubBenefits,
                attr: filters.attractions,
                acc: filters.disabledAccessibility,
                pet: filters.petsAllowed,
                water: filters.water,
                cp: filters.cockpit,
                el: filters.electricity,
                limit: 10
            }));
            history.replace('/search-poi');
        }
    };




    return <div id="home_page">
        <img alt="pleinair club" src="/images/PLEINAIRCLUB_orizzontale_RGB.png" id="text_logo"/>
        <div className="content">
            <input type="text" id="search_poi" readOnly className="search" value={keyword} placeholder={strings.search_poi} onClick={event => { event.preventDefault(); setShowSearch(true)}} />
        </div>
        <div className="category-list">
            <div className="category" onClick={() => history.push('/search-poi/campsites')}>
                <img alt="campasites" src="/images/campsites.png"/>
                <span className="title">{strings.campsites}</span>
            </div>
            <div className="category" onClick={() => history.push('/search-poi/service-areas')}>
                <img alt="services areas" src="/images/service_areas.png" />
                <span className="title">{strings.service_areas}</span>
            </div>
            <div className="category" onClick={() => history.push('/search-poi/parking-areas')}>
                <img alt="parking areas" src="/images/parking_areas.png"/>
                <span className="title">{strings.parking_areas}</span>
            </div>
            <div className="category" onClick={() => history.push('/search-poi/club-benefits')}>
                <img alt="club benefits" src="/images/club_benefits.png"/>
                <span className="title">{strings.club_benefits}</span>
            </div>
        </div>
        <div className="buttons-list">
            <button className="btn" id="attractions_button" onClick={() => history.push('/search-poi/attractions')}>{strings.attractions}</button>
            <a className="btn" id="allianz_button" href="https://geolocator.allianz.it/ricerca" target="_blank"></a>
        </div>
        <hr/>
        <FeaturedPoisSection/>
        <TrendingPoisSection/>
        <NewsSection/>
        <button className="btn" id="show_all_wall" onClick={() => history.push('/social-wall')}>{strings.show_all}</button>
        <Navbar/>
        <SearchModal defaultCampsites={campsites} defaultServiceAreas={serviceAreas} defaultParkingAreas={parkingAreas} 
                     defaultClubBenefits={clubBenefits} 
                     defaultAttractions={attractions} onGoBack={() => setShowSearch(false)} show={showSearch} onApplyFilters={applyFilters}/>
    </div>;
};




export default HomePage;
